<section class="section-div">
  <div class="header-div">
    <h4><i class="fas fa-file-alt"></i> Host Institution Details</h4>
  </div>
  <div class="p-3">
    <p class="sub-title">Instructions:</p>
  </div>
  <div class="ml-3">
    <p>
      1. For applicants from Host or Non-Academic Institutions, please select
      <b>Not Applicable</b> option for Incubation Centre Details if no such
      facility is available.
    </p>
    <p class="mt-2 mb-4">
      2. Similarly, applicants from Incubation Centres without a Host or
      Non-Academic Institutions, select <b>Not Applicable</b> option for Host or
      Non-Academic Institution Details.
    </p>
  </div>
  <div class="content-details pt-4">
    <form action="" [formGroup]="hostinstitution">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-12 p-3">
          <p class="sub-title">Host or Non-Academic Institution Details</p>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 mb-3">
          <div class="form-rows mt-3">
            <mat-button-toggle-group
              class="custom-toggle-group"
              formControlName="hostInstitutionAplicable"
              (change)="onShowInMenuChange($event.value)"
              [value]="setting.hostInstitutionAplicable.value"
              [disabled]="showForm"
            >
              <mat-button-toggle
                value="true"
                [ngClass]="{
                  'is-selected': setting.hostInstitutionAplicable.value === true
                }"
                >Applicable</mat-button-toggle
              >
              <mat-button-toggle
                value="false"
                [ngClass]="{
                  'is-selected':
                    setting.hostInstitutionAplicable.value === false
                }"
                >Not Applicable</mat-button-toggle
              >
            </mat-button-toggle-group>
          </div>
        </div>
        <div
          class="col-lg-4 col-md-6 col-sm-6 col-12"
          *ngIf="showInMenu === 'true'"
        >
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Name of the Host Institution
                <span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                readonly="{{ showForm }}"
                placeholder="Enter Name of the Host Institution"
                formControlName="hostInstitution"
                maxlength="70"
                (keydown.enter)="preventEnterKey($event)"
                oninput="this.value = this.value.replace(/[^a-zA-Z/ ]/g,'')"
              />
              <mat-error
                *ngIf="
                  setting.hostInstitution.touched &&
                  setting.hostInstitution.errors
                "
              >
                <span *ngIf="setting.hostInstitution.errors.required"
                  >Please Enter Name of the Host Institution
                </span>
                <span *ngIf="setting.hostInstitution?.errors?.pattern">
                  Whitespace not allowed
                </span>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div
          class="col-lg-4 col-md-6 col-sm-6 col-12"
          *ngIf="showInMenu === 'true'"
        >
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>Address <span class="text-danger">*</span></mat-label>
              <input
                matInput
                readonly="{{ showForm }}"
                placeholder="Enter Address"
                formControlName="address"
                (keydown.enter)="preventEnterKey($event)"
              />
              <mat-error
                *ngIf="setting.address.touched && setting.address.errors"
              >
                <span *ngIf="setting.address.errors.required"
                  >Please Enter Address</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div
          class="col-lg-4 col-md-6 col-sm-6 col-12"
          *ngIf="showInMenu === 'true'"
        >
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Phone Number <span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                placeholder="Enter Phone Number"
                type="text"
                readonly="{{ showForm }}"
                formControlName="phone"
                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                maxlength="10"
                minlength="10"
                (keydown.enter)="preventEnterKey($event)"
              />
              <mat-error
                *ngIf="hostinstitution.get('phone').hasError('required')"
              >
                Please Enter Phone Number
              </mat-error>
              <mat-error
                *ngIf="hostinstitution.get('phone').hasError('pattern')"
              >
                <i class="fas fa-exclamation-triangle"></i>
                Invalid Phone Number
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div
          class="col-lg-4 col-md-6 col-sm-6 col-12"
          *ngIf="showInMenu === 'true'"
        >
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>E-mail <span class="text-danger">*</span></mat-label>
              <input
                matInput
                formControlName="email"
                placeholder="Enter E-mail"
                readonly="{{ showForm }}"
                type="text"
                (keydown.space)="$event.preventDefault()"
                (keydown.enter)="preventEnterKey($event)"
              />

              <mat-error *ngIf="setting.email.touched && setting.email.errors">
                <span *ngIf="setting.email.errors.required"
                  >Please Enter E-Mail</span
                >
                <span *ngIf="setting.email.errors.pattern">
                  <i class="fas fa-exclamation-triangle"></i>
                  Please Enter Valid E-Mail
                </span>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div
          class="col-lg-4 col-md-6 col-sm-6 col-12"
          *ngIf="showInMenu === 'true'"
        >
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>Website <span class="text-danger">*</span></mat-label>
              <input
                matInput
                formControlName="website"
                placeholder="Enter Website"
                type="text"
                (keydown.space)="$event.preventDefault()"
                readonly="{{ showForm }}"
              />
              <mat-error
                *ngIf="setting.website.touched && setting.website.errors"
              >
                <span *ngIf="setting.website.errors.required"
                  >Please Enter Website is required</span
                >
                <span *ngIf="setting.website.errors.website">
                  <i class="fas fa-exclamation-triangle"></i>
                  Invalid Website
                </span>
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div
          class="col-lg-4 col-md-4 col-md-12 col-12"
          *ngIf="showInMenu === 'true'"
        >
          <div class="form-rows mt-3" *ngIf="!showForm">
            <mat-label
              >Upload HI Registration Document
              <span class="text-danger">*</span></mat-label
            >
            <label
              *ngIf="disName != '✔ Uploaded'"
              for="input-file-id"
              class="md-button md-raised md-primary"
            >
              Choose File
              <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
              <span class="ml-3">{{ disName }}</span>
              <input
                class="d-none"
                id="input-file-id"
                type="file"
                (change)="fileUpload($event)"
              />
            </label>
            <label
              *ngIf="disName == '✔ Uploaded'"
              for="input-file-id"
              class="md-button md-raised md-accent"
            >
              Update File
              <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
              <span class="ml-3">{{ disName }}</span>
              <input
                class="d-none"
                id="input-file-id"
                type="file"
                (change)="fileUpload($event)"
              />
            </label>
            <span class="noti-span">
              (Supported Format: pdf) (max file size: 5mb)
            </span>
            <p *ngIf="fileErrorShow == true" class="text-danger">
              File size exceeds the limit ({{ maxSizeMB }}MB)
            </p>
            <div class="mt-2 mb-3" *ngIf="disNames == '✔ Uploaded' && getValue">
              <a class="pdf-btn" href="{{ FileName }}" target="_blank"
                >Download & View Document</a
              >
            </div>
            <mat-error *ngIf="fileError == true">
              <span>Upload HI Registration Document</span>
            </mat-error>
          </div>

          <div class="form-rows mt-3" *ngIf="showForm" disabled>
            <mat-label
              >Upload HI Registration Document
              <span class="text-danger">*</span></mat-label
            >
            <label
              *ngIf="disName != '✔ Uploaded'"
              for="input-file-id"
              class="md-button md-raised md-primary"
            >
              Choose File
              <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
              <span class="ml-3">{{ disName }}</span>
              <input class="d-none" id="input-file-id" readonly />
            </label>
            <label
              *ngIf="disName == '✔ Uploaded'"
              for="input-file-id"
              class="md-button md-raised md-accent"
              style="cursor: not-allowed"
            >
              Update File
              <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
              <span class="ml-3">{{ disName }}</span>
              <input class="d-none" id="input-file-id" readonly />
            </label>
            <span class="noti-span">
              (Supported Format: pdf) (max file size: 5mb)
            </span>
            <p
              *ngIf="
                logoCheck &&
                selecetdFile &&
                selecetdFile.size / (1024 * 1024) > maxSizeMB
              "
              class="text-danger"
            >
              File size exceeds the limit ({{ maxSizeMB }}MB)
            </p>
            <div class="mt-2 mb-3" *ngIf="disNames == '✔ Uploaded' && getValue">
              <a class="pdf-btn" href="{{ FileName }}" target="_blank"
                >Download & View Document</a
              >
            </div>
            <mat-error *ngIf="fileError == true">
              <span>Upload HI Registration Document</span>
            </mat-error>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 p-3">
          <p class="sub-title">Incubation Centre Details</p>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 mb-3">
          <div class="form-rows toggle mt-3">
            <mat-button-toggle-group
              class="custom-toggle-group"
              formControlName="incubationCentreAplicable"
              (change)="incubationCentreAplicables($event.value)"
              [value]="setting.incubationCentreAplicable.value"
              [disabled]="showForm"
            >
              <mat-button-toggle
                value="true"
                [ngClass]="{
                  'is-selected':
                    setting.incubationCentreAplicable.value === true
                }"
                >Applicable</mat-button-toggle
              >
              <mat-button-toggle
                value="false"
                [ngClass]="{
                  'is-selected':
                    setting.incubationCentreAplicable.value === false
                }"
                >Not Applicable</mat-button-toggle
              >
            </mat-button-toggle-group>
          </div>
        </div>
        <div
          class="col-lg-4 col-md-6 col-sm-6 col-12"
          *ngIf="showincubationCentreAplicable === 'true'"
        >
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Name of the Incubation Centre
                <span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                readonly="{{ showForm }}"
                placeholder="Enter Name of the Incubation Centre"
                formControlName="incubationCentre"
                maxlength="70"
                (keydown.enter)="preventEnterKey($event)"
              />
              <mat-error
                *ngIf="
                  setting.incubationCentre.touched &&
                  setting.incubationCentre.errors
                "
              >
                <span *ngIf="setting.incubationCentre.errors.required"
                  >Please Enter Name of the Incubation Centre</span
                >
                <span *ngIf="setting.incubationCentre?.errors?.pattern">
                  Enter Valid Name (or) Whitespace not allowed
                </span>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div
          class="col-lg-4 col-md-6 col-sm-6 col-12"
          *ngIf="showincubationCentreAplicable === 'true'"
        >
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Registration Number
                <span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                placeholder="Enter Registration Number"
                type="text"
                readonly="{{ showForm }}"
                formControlName="registrationNumber"
                (keydown.enter)="preventEnterKey($event)"
              />
              <mat-error
                *ngIf="
                  setting.registrationNumber.touched &&
                  setting.registrationNumber.errors
                "
              >
                <span *ngIf="setting.registrationNumber.errors.required">
                  Please Enter Valid Registration Number</span
                >
                <span *ngIf="setting.registrationNumber?.errors?.pattern">
                  Enter Valid Registration Number (or) Whitespace not allowed
                </span>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div
          class="col-lg-4 col-md-6 col-sm-6 col-12"
          *ngIf="showincubationCentreAplicable === 'true'"
        >
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Focus Sector<span class="text-danger"> *</span></mat-label
              >
              <mat-select
                formControlName="sector"
                multiple
                (selectionChange)="onSelectionChange($event)"
                (keydown.enter)="preventEnterKey($event)"
                [ngClass]="{
                  'is-invalid': setting.sector.touched && setting.sector.errors
                }"
                disabled="{{ showForm }}"
              >
                <mat-option
                  *ngFor="let list of districtdataList"
                  [disabled]="isDisabled(list)"
                  [value]="list"
                >
                  {{ list }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="setting.sector.touched && setting.sector.errors"
              >
                <span *ngIf="setting.sector.errors.required"
                  >Please Select Focus Sector</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div
          class="col-lg-4 col-md-4 col-md-12 col-12"
          *ngIf="showincubationCentreAplicable === 'true'"
        >
          <div class="form-rows mt-3" *ngIf="!showForm">
            <mat-label
              >Upload your Registration certificate
              <span class="text-danger">*</span></mat-label
            >
            <label
              *ngIf="disName2 != '✔ Uploaded'"
              for="input-file-id2"
              class="md-button md-raised md-primary"
            >
              Choose File
              <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
              <span class="ml-3">{{ disName2 }}</span>
              <input
                class="d-none"
                id="input-file-id2"
                type="file"
                (change)="fileUpload2($event)"
              />
            </label>
            <label
              *ngIf="disName2 == '✔ Uploaded'"
              for="input-file-id2"
              class="md-button md-raised md-accent"
            >
              Update File
              <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
              <span class="ml-3">{{ disName2 }}</span>
              <input
                class="d-none"
                id="input-file-id2"
                type="file"
                (change)="fileUpload2($event)"
              />
            </label>
            <span class="noti-span">
              (Supported Format: pdf) (max file size: 5mb)
            </span>
            <p *ngIf="fileErrorShow2 == true" class="text-danger">
              File size exceeds the limit ({{ maxSizeMB2 }}MB)
            </p>
            <div
              class="mt-2 mb-3"
              *ngIf="disNames2 == '✔ Uploaded' && getValue"
            >
              <a class="pdf-btn" href="{{ FileName2 }}" target="_blank"
                >Download & View Document</a
              >
            </div>
            <mat-error *ngIf="fileError2 == true">
              <span>Registration Document is required</span>
            </mat-error>
          </div>

          <div class="form-rows mt-3" *ngIf="showForm" disabled>
            <mat-label
              >Upload your Registration certificate
              <span class="text-danger">*</span></mat-label
            >
            <label
              *ngIf="disName2 != '✔ Uploaded'"
              for="input-file-id2"
              class="md-button md-raised md-primary"
            >
              Choose File
              <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
              <span class="ml-3">{{ disName2 }}</span>
              <input class="d-none" id="input-file-id2" readonly />
            </label>
            <label
              *ngIf="disName2 == '✔ Uploaded'"
              for="input-file-id2"
              class="md-button md-raised md-accent"
              style="cursor: not-allowed"
            >
              Update File
              <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
              <span class="ml-3">{{ disName2 }}</span>
              <input class="d-none" id="input-file-id2" readonly />
            </label>
            <span class="noti-span">
              (Supported Format: pdf) (max file size: 5mb)
            </span>
            <p
              *ngIf="
                logoCheck2 &&
                selecetdFile2 &&
                selecetdFile2.size / (1024 * 1024) > maxSizeMB2
              "
              class="text-danger"
            >
              File size exceeds the limit ({{ maxSizeMB2 }}MB)
            </p>
            <div
              class="mt-2 mb-3"
              *ngIf="disNames2 == '✔ Uploaded' && getValue"
            >
              <a class="pdf-btn" href="{{ FileName2 }}" target="_blank"
                >Download & View Document</a
              >
            </div>
            <mat-error *ngIf="fileError2 == true">
              <span>Registration Document is required</span>
            </mat-error>
          </div>
        </div>
      </div>
      <div class="text-center mt-3">
        <button
          mat-raised-button
          color="primary"
          (click)="saveBtn()"
          *ngIf="!showForm"
        >
          Save & Continue
        </button>
      </div>
    </form>
  </div>
</section>
<!-- modal -->
<div id="editModals" class="modal">
  <div class="modal-content text-center">
    <div class="text-center">
      <img
        class="image-sec"
        style="width: 100px"
        src="/assets/images/attention -man.gif"
        alt=""
      />
    </div>
    <h4
      *ngIf="showInMenu === 'false'"
      class="mb-3"
      style="font-size: 17px; font-weight: 500"
    >
      Host / Academic Institution Details is set as Not Applicable !
    </h4>
    <h4
      *ngIf="showincubationCentreAplicable === 'false'"
      class="mb-3"
      style="font-size: 17px; font-weight: 500"
    >
      Incubation Centre Details is set as Not Applicable !
    </h4>
    <h4 style="font-size: 20px; font-weight: 500">
      Are you sure to continue ?
    </h4>
    <div class="text-center mt-2">
      <button class="incubatorBtn" (click)="closeModal()">No</button>
      <button class="successBtn ml-2" (click)="saveModal()">Yes</button>
    </div>
  </div>
</div>
